import React from 'react';
import { useAppSelector } from 'app/store';
import { selectOnBoardingPresentationStatus, selectUserInfo } from 'app/store/user';
import PreloaderIcon, { RyeLogoSizeClass } from 'components/Preloader';
import { ReactComponent as GreetingIcon } from 'assets/icons/greeting.svg';

interface LoaderWrapperProps {
  children: React.ReactNode;
}

export const LoaderWrapper = ({ children }: LoaderWrapperProps) => {
  const userInfo = useAppSelector(selectUserInfo);
  const userName =
    userInfo?.firstName || userInfo?.displayName || userInfo?.displayName || 'Anonymous Beaver';
  const onBoardingPresentationStatus = useAppSelector(selectOnBoardingPresentationStatus);

  const show = Boolean(userInfo);

  return (
    <>
      {show ? (
        <>{children}</>
      ) : (
        <div className="dashboard-preloader">
          <PreloaderIcon size={RyeLogoSizeClass.small} />
        </div>
      )}

      <>
        {show &&
        typeof onBoardingPresentationStatus !== 'undefined' &&
        !onBoardingPresentationStatus ? (
          <div
            className={onBoardingPresentationStatus ? 'dashboard-cover-hidden' : 'dashboard-cover'}
          >
            <GreetingIcon />
            <span>Welcome, {userName}!</span>
          </div>
        ) : (
          <>{null}</>
        )}
      </>
    </>
  );
};
